import { render, staticRenderFns } from "./SCBS.vue?vue&type=template&id=c5a8677a&scoped=true"
import script from "./SCBS.vue?vue&type=script&lang=js"
export * from "./SCBS.vue?vue&type=script&lang=js"
import style0 from "./SCBS.vue?vue&type=style&index=0&id=c5a8677a&prod&scoped=true&lang=css"
import style1 from "./SCBS.vue?vue&type=style&index=1&id=c5a8677a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a8677a",
  null
  
)

export default component.exports